import Announcement from './Announcements';

export default Announcement;
